// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

body {
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}

.professional-detail_professional-detail__Y-EXR {
  position: relative;
  margin-top: 24px;
  margin-bottom: 24px;
  padding: 0px;
}
@media (max-width: 1080px) {
  .professional-detail_professional-detail__Y-EXR {
    padding: 0 20px;
  }
}
.professional-detail_professional-detail__content__hrNNX {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 416px;
  gap: 32px;
  align-items: start;
}
@media (max-width: 990px) {
  .professional-detail_professional-detail__content__hrNNX {
    grid-template-columns: minmax(0, 1fr);
  }
}
.professional-detail_professional-detail__content__booking__GDJdB {
  position: sticky;
  top: 88px;
  align-self: start;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  padding-bottom: 16px;
  scrollbar-width: thin;
  scrollbar-color: rgba(130, 177, 148, 0.45) transparent;
}
.professional-detail_professional-detail__content__booking__GDJdB::-webkit-scrollbar {
  width: 6px;
}
.professional-detail_professional-detail__content__booking__GDJdB::-webkit-scrollbar-track {
  background: transparent;
}
.professional-detail_professional-detail__content__booking__GDJdB::-webkit-scrollbar-thumb {
  background: rgba(130, 177, 148, 0.45);
  border-radius: 999px;
}
.professional-detail_professional-detail__content__booking__GDJdB::-webkit-scrollbar-thumb:hover {
  background: rgba(130, 177, 148, 0.75);
}
@media (max-width: 990px) {
  .professional-detail_professional-detail__content__booking__GDJdB {
    position: static;
    max-height: none;
    overflow-y: visible;
    padding-right: 0;
    padding-bottom: 0;
  }
}
.professional-detail_professional-detail__main__mvmPb {
  padding-right: 35px;
}
@media (max-width: 990px) {
  .professional-detail_professional-detail__main__mvmPb {
    padding-right: 0;
  }
}
.professional-detail_professional-detail__price__\\+IjsU {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-family: inherit;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_price-icon__wCNld {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #e8f5e9;
  color: #2e7d32;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_price-label__ANN4S {
  font-size: 0.95rem;
  color: #666;
  font-weight: 500;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_price-value__nulqi {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2e7d32;
  letter-spacing: 0.5px;
}
.professional-detail_professional-detail__image__UKNQb {
  max-width: 100%;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
}
.professional-detail_professional-detail__card__g-ufe {
  margin-top: 20px;
  border: 1px solid #82B194;
  border-radius: 16px;
}
.professional-detail_professional-detail__card-header__XzoXy {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 768px) {
  .professional-detail_professional-detail__card-header__XzoXy {
    align-items: flex-start;
  }
}
.professional-detail_professional-detail__title__Gmnfa {
  font-size: 38px;
  color: #82B194;
  line-height: 1.2;
}
@media (max-width: 768px) {
  .professional-detail_professional-detail__title__Gmnfa {
    font-size: 28px;
  }
}
.professional-detail_professional-detail__subtitle__wd4c6 {
  font-size: 20px;
  color: #82B194;
  margin-bottom: 15px;
}
.professional-detail_professional-detail__card-content__tUVBj {
  padding: 20px;
  border-top: 1px solid #82B194;
}
.professional-detail_professional-detail__description__Tv5bp {
  font-size: 16px;
  color: #82B194;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: pre-wrap;
  max-width: 100%;
}
.professional-detail_professional-detail__btn__MKKX4 {
  font-size: 16px;
  text-decoration: none;
  color: #C95C5C;
  border: none;
  background: transparent;
}
.professional-detail_professional-detail__sticky-panel__sVZjo {
  position: sticky;
  top: 23px;
  z-index: 2;
  margin-bottom: 40px;
}
.professional-detail_professional-detail__calendar__sejOg {
  text-align: center;
  max-width: 416px;
  width: 100%;
  margin: 0 auto;
  height: 100%;
}
@media (max-width: 768px) {
  .professional-detail_professional-detail__calendar__sejOg {
    max-width: 100%;
  }
}
@media (max-width: 500px) {
  .professional-detail_professional-detail__calendar__sejOg {
    width: 100%;
  }
}
.professional-detail_professional-detail__calendar-title__gKgvr {
  font-size: 29px;
  color: #445867;
  font-weight: 700;
  margin-bottom: 0;
  text-align: left;
}
.professional-detail_professional-detail__calendar-legend__eMgdN {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin: 16px 0;
  padding: 10px;
  border-radius: 8px;
  flex-wrap: nowrap;
}
@media (max-width: 500px) {
  .professional-detail_professional-detail__calendar-legend__eMgdN {
    gap: 10px;
    padding: 8px;
  }
}
.professional-detail_professional-detail__legend-item__X-rx\\+ {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #82B194;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .professional-detail_professional-detail__legend-item__X-rx\\+ {
    font-size: 10px;
  }
}
.professional-detail_professional-detail__legend-indicator__RfdVM {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}
.professional-detail_professional-detail__legend-indicator--available__V3IDX {
  border: 2px solid #7A9E7E;
  background-color: transparent;
}
.professional-detail_professional-detail__legend-indicator--selected__7I0zX {
  background-color: #C95C5C;
}
.professional-detail_professional-detail__calendar-button__KvOxS {
  width: 100%;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  border: none;
  border-radius: 16px;
  background-color: #C95C5C;
  padding: 12px;
  color: #EFF0EC;
  font-size: 21px;
  font-weight: bold;
  margin: 0;
  cursor: pointer;
  transition: transform 0.2s, background-color 0.2s;
}
.professional-detail_professional-detail__calendar-button__KvOxS:hover {
  background-color: rgb(194.6543778802, 72.8456221198, 72.8456221198);
}
.professional-detail_professional-detail__calendar-button__KvOxS:active {
  transform: scale(0.98);
}
.professional-detail_professional-detail__calendar-button__KvOxS:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.professional-detail_professional-detail__social__gk9Dj {
  margin-top: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.professional-detail_professional-detail__social-title__75dFE {
  font-size: 15px;
  font-weight: bold;
  margin: 0;
  color: #708ca1;
}
.professional-detail_professional-detail__social-icons__QMahV {
  display: flex;
  align-items: center;
  gap: 8px;
}
.professional-detail_professional-detail__social-wrapper__ODtwZ {
  margin-top: 16px;
}
.professional-detail_professional-detail__back-button-container__WjAWZ {
  margin-bottom: 19px;
}
.professional-detail_professional-detail__back-button__oEnZz {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 14px;
  border-radius: 14px;
  border: 1px solid rgba(16, 25, 21, 0.1);
  background: rgba(248, 244, 240, 0.92);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.03);
  text-decoration: none;
  color: #13231d;
  font-size: 14px;
  font-weight: 800;
}
.professional-detail_professional-detail__back-button__oEnZz:hover {
  background: #fff;
}
.professional-detail_professional-detail__modality-container__e5HVX {
  margin-bottom: 20px;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  animation: professional-detail_fadeIn__fWNG7 0.3s ease-in;
}
.professional-detail_professional-detail__modality-text__hF5t0 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #82B194;
}
.professional-detail_professional-detail__modality-text--presencial__fp8uc svg {
  color: #82B194;
}
.professional-detail_professional-detail__modality-text--virtual__papXp svg {
  color: #C95C5C;
}
.professional-detail_professional-detail__modality-selection__\\+6z38 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.professional-detail_professional-detail__modality-header__GRVml {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #445867;
  margin-bottom: 10px;
}
.professional-detail_professional-detail__radio-group__PytGf {
  display: flex;
  justify-content: center;
  gap: 15px;
}
.professional-detail_professional-detail__radio-group--open__JhoGJ {
  background-color: #f8fbff;
  border-radius: 9px;
  border: 1px solid #e1ecf5;
}
@media (max-width: 400px) {
  .professional-detail_professional-detail__radio-group__PytGf {
    flex-direction: column;
  }
}
.professional-detail_professional-detail__radio-group__PytGf label {
  margin: 0;
  flex: 1 1;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  padding: 5px 10px;
  transition: all 0.2s ease;
  background: white;
  display: flow-root;
  justify-content: center;
  align-items: center;
}
.professional-detail_professional-detail__radio-group__PytGf label:hover {
  background-color: #f9f9f9;
  border-color: #d0d0d0;
}
.professional-detail_professional-detail__radio-group__PytGf label.professional-detail_active-radio__gbZ0U {
  border: 2px solid #445867;
  background-color: white;
}
.professional-detail_professional-detail__radio-group__PytGf label.professional-detail_active-radio__gbZ0U span {
  font-weight: 700;
  color: #445867;
}
.professional-detail_professional-detail__radio-group__PytGf label .MuiTypography-root {
  font-size: 14px;
  font-weight: 500;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
}
.professional-detail_professional-detail__radio-group__PytGf label .MuiTypography-root svg {
  font-size: 32px;
}
.professional-detail_professional-detail__radio-group__PytGf label .professional-detail_MuiRadio-root__spAOO {
  display: none;
}
.professional-detail_professional-detail__consult-value__Bw-Le {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 20px;
  border: 1px solid #E0E0E0;
  border-radius: 10px;
  background-color: #FFFFFF;
  margin-bottom: 25px;
}
.professional-detail_professional-detail__consult-value-left__vopzl {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  font-size: 14px;
  font-weight: 500;
}
.professional-detail_professional-detail__consult-value-left__vopzl span {
  font-size: 16px;
}
.professional-detail_professional-detail__consult-value-left__vopzl svg {
  color: #555;
  font-size: 32px;
}
.professional-detail_professional-detail__consult-value-right__Ks2Jz {
  font-size: 21px;
  font-weight: 800;
  color: #445867;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_view-verified-icon__Wks0S {
  color: #C95C5C;
  font-size: 0.7em !important;
  margin-left: 5px;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_view-meta-grid__zdoqw {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 15px;
  margin-top: 15px;
  padding: 15px;
  background-color: #fafafa;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_view-meta-item__LQUoA {
  display: flex;
  align-items: center;
  gap: 12px;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_meta-icon-wrapper__\\+Ww-J {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: white;
  color: #82B194;
  flex-shrink: 0;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_meta-icon-wrapper__\\+Ww-J.professional-detail_accent__v9JkF {
  background-color: rgba(201, 92, 92, 0.1);
  color: #C95C5C;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_meta-icon-wrapper__\\+Ww-J.professional-detail_green__wwRa9 {
  background-color: #e8f5e9;
  color: #2e7d32;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_meta-content__u8tVT {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_meta-label__9speQ {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: white;
  font-weight: 600;
  letter-spacing: 0.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_meta-value__aGF8C {
  font-size: 0.95rem;
  color: #82B194;
  font-weight: 600;
  line-height: 1.2;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_view-tags-section__zV2f7 {
  margin-top: 20px;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_view-tags-section__zV2f7 .professional-detail_tags-header__SWddH {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_view-tags-section__zV2f7 .professional-detail_tags-label__KRiZ2 {
  font-size: 0.9rem;
  color: rgb(192.8078817734, 216.1921182266, 201.763546798);
  font-weight: 600;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_view-tags-section__zV2f7 .professional-detail_tags-container__EhHQy {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.professional-detail_professional-detail__Y-EXR .professional-detail_view-tags-section__zV2f7 .professional-detail_tag-badge__T3LdL {
  font-size: 0.75rem;
  padding: 4px 12px;
  background-color: #f0f2f5;
  border-radius: 16px;
  color: #445867;
  border: 1px solid #e0e0e0;
  font-weight: 500;
}

@keyframes professional-detail_fadeIn__fWNG7 {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.professional-detail_tabs__\\+KoDQ {
  margin: 0px 0 40px 0;
  border: 1px solid #E1E8ED;
  border-radius: 16px;
}
.professional-detail_tabs__content__WoVRd {
  display: flex;
  gap: 20px;
  color: #82B194;
  padding: 30px 20px;
}
.professional-detail_tabs__title__FZd3M {
  font-size: 24px;
  color: #445867;
  font-weight: 700;
  margin-bottom: 16px;
}
.professional-detail_tabs__image__Sgi0Z {
  padding-right: 20px;
}
@media (max-width: 768px) {
  .professional-detail_tabs__image__Sgi0Z {
    padding-right: 0;
    padding-bottom: 20px;
  }
}
.professional-detail_tabs__description__QAsGY {
  font-size: 16px;
  color: #82B194;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: pre-wrap;
  max-width: 100%;
  width: 100%;
}
.professional-detail_tabs__empty-state__ZvZl\\+ {
  padding: 40px 20px;
  text-align: center;
  color: #8898aa;
  font-size: 15px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/pages/ProfessionalDetail/professional-detail.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACI,oFDGQ;ACcZ;;AAdA;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAiBJ;AAfI;EANJ;IAOQ,eAAA;EAkBN;AACF;AAhBI;EACI,aAAA;EACA,2CAAA;EACA,SAAA;EACA,kBAAA;AAkBR;AAhBQ;EANJ;IAOQ,qCAAA;EAmBV;AACF;AAjBQ;EACI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sDAAA;AAmBZ;AAjBY;EACI,UAAA;AAmBhB;AAhBY;EACI,uBAAA;AAkBhB;AAfY;EACI,qCAAA;EACA,oBAAA;AAiBhB;AAfgB;EACI,qCAAA;AAiBpB;AAbY;EA7BJ;IA8BQ,gBAAA;IACA,gBAAA;IACA,mBAAA;IACA,gBAAA;IACA,iBAAA;EAgBd;AACF;AAZI;EACI,mBAAA;AAcR;AAZQ;EAHJ;IAIQ,gBAAA;EAeV;AACF;AAZI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;AAcR;AAXI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAaR;AAVI;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;AAYR;AATI;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAWR;AAPI;EACI,eAAA;EACA,WAAA;EACA,mBD7DQ;EC8DR,gBAAA;AASR;AANI;EACI,gBAAA;EACA,yBAAA;EACA,mBDpEQ;AC4EhB;AALI;EACI,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAOR;AALQ;EANJ;IAOQ,uBAAA;EAQV;AACF;AALI;EACI,eAAA;EACA,cDzHe;EC0Hf,gBAAA;AAOR;AALQ;EALJ;IAMQ,eAAA;EAQV;AACF;AALI;EACI,eAAA;EACA,cDnIe;ECoIf,mBAAA;AAOR;AAJI;EACI,aAAA;EACA,6BAAA;AAMR;AAHI;EACI,eAAA;EACA,cD9Ie;EC+If,oFDpJI;ECqJJ,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AAKR;AAFI;EACI,eAAA;EACA,qBAAA;EACA,cDtIe;ECuIf,YAAA;EACA,uBAAA;AAIR;AADI;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAGR;AAAI;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AAER;AAAQ;EAPJ;IAQQ,eAAA;EAGV;AACF;AADQ;EAXJ;IAYQ,WAAA;EAIV;AACF;AADI;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAGR;AAAI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EAEA,kBAAA;EACA,iBAAA;AACR;AACQ;EAVJ;IAWQ,SAAA;IACA,YAAA;EAEV;AACF;AACI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cDlNe;ECmNf,mBAAA;AACR;AACQ;EARJ;IASQ,eAAA;EAEV;AACF;AACI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AACR;AACQ;EACI,yBAAA;EACA,6BAAA;AACZ;AAEQ;EACI,yBDlNW;ACkNvB;AAII;EACI,WAAA;EACA,oFDhPI;ECiPJ,YAAA;EACA,mBDxMQ;ECyMR,yBD3Ne;EC4Nf,aAAA;EACA,cDzOe;EC0Of,eAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,iDAAA;AAFR;AAIQ;EACI,mEAAA;AAFZ;AAKQ;EACI,sBAAA;AAHZ;AAMQ;EACI,sBAAA;EACA,mBAAA;AAJZ;AAQI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AANR;AASI;EACI,eAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;AAPR;AAUI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AARR;AAWI;EACI,gBAAA;AATR;AAYI;EACI,mBAAA;AAVR;AAaI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uCAAA;EACA,qCAAA;EACA,2CAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAXR;AAaQ;EACI,gBAAA;AAXZ;AAgBI;EACI,mBAAA;EAKA,oFDlUI;ECmUJ,yDAAA;AAlBR;AAqBI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cDtUe;ACmTvB;AAsBY;EACI,cD1UO;ACsTvB;AAyBY;EACI,cD7TO;ACsSvB;AA4BI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AA1BR;AA6BI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AA3BR;AA8BI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AA5BR;AA8BQ;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;AA5BZ;AA+BQ;EAXJ;IAYQ,sBAAA;EA5BV;AACF;AA8BQ;EACI,SAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AA5BZ;AA8BY;EACI,yBAAA;EACA,qBAAA;AA5BhB;AA+BY;EACI,yBAAA;EACA,uBAAA;AA7BhB;AA+BgB;EACI,gBAAA;EACA,cAAA;AA7BpB;AAiCY;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AA/BhB;AAiCgB;EACI,eAAA;AA/BpB;AAmCY;EACI,aAAA;AAjChB;AAsCI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AApCR;AAsCQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AApCZ;AAsCY;EACI,eAAA;AApChB;AAuCY;EACI,WAAA;EACA,eAAA;AArChB;AAyCQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAvCZ;AA8CI;EACI,cDxbe;ECybf,2BAAA;EACA,gBAAA;AA5CR;AA+CI;EACI,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AA7CR;AAgDI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AA9CR;AAiDI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cDzee;EC0ef,cAAA;AA/CR;AAiDQ;EACI,wCAAA;EACA,cD3dW;AC4avB;AAkDQ;EACI,yBAAA;EACA,cAAA;AAhDZ;AAoDI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AAlDR;AAqDI;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAnDR;AAsDI;EACI,kBAAA;EACA,cD1gBe;EC2gBf,gBAAA;EACA,gBAAA;AApDR;AAuDI;EACI,gBAAA;AArDR;AAuDQ;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AArDZ;AAwDQ;EACI,iBAAA;EACA,yDAAA;EACA,gBAAA;AAtDZ;AAyDQ;EACI,aAAA;EACA,eAAA;EACA,QAAA;AAvDZ;AA0DQ;EACI,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAxDZ;;AA6DA;EACI;IACI,UAAA;IACA,2BAAA;EA1DN;EA6DE;IACI,UAAA;IACA,wBAAA;EA3DN;AACF;AA8DA;EACI,oBAAA;EACA,yBAAA;EACA,mBD1hBY;AC8dhB;AA8DI;EACI,aAAA;EACA,SAAA;EACA,cDpkBe;ECqkBf,kBAAA;AA5DR;AA+DI;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AA7DR;AAgEI;EACI,mBAAA;AA9DR;AAgEQ;EAHJ;IAIQ,gBAAA;IACA,oBAAA;EA7DV;AACF;AAgEI;EACI,eAAA;EACA,cD1lBe;EC2lBf,oFDhmBI;ECimBJ,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;AA9DR;AAiEI;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA/DR","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\r\n\r\nbody {\r\n    font-family: $font-main;\r\n}\r\n\r\n.professional-detail {\r\n    position: relative;\r\n    margin-top: 24px;\r\n    margin-bottom: 24px;\r\n    padding: 0px;\r\n\r\n    @media (max-width: 1080px) {\r\n        padding: 0 20px;\r\n    }\r\n\r\n    &__content {\r\n        display: grid;\r\n        grid-template-columns: minmax(0, 1fr) 416px;\r\n        gap: 32px;\r\n        align-items: start;\r\n\r\n        @media (max-width: 990px) {\r\n            grid-template-columns: minmax(0, 1fr);\r\n        }\r\n\r\n        &__booking {\r\n            position: sticky;\r\n            top: 88px;\r\n            align-self: start;\r\n            max-height: calc(100vh - 100px);\r\n            overflow-y: auto;\r\n            overflow-x: hidden;\r\n            padding-right: 4px;\r\n            padding-bottom: 16px;\r\n            scrollbar-width: thin;\r\n            scrollbar-color: rgba(130, 177, 148, 0.45) transparent;\r\n\r\n            &::-webkit-scrollbar {\r\n                width: 6px;\r\n            }\r\n\r\n            &::-webkit-scrollbar-track {\r\n                background: transparent;\r\n            }\r\n\r\n            &::-webkit-scrollbar-thumb {\r\n                background: rgba(130, 177, 148, 0.45);\r\n                border-radius: 999px;\r\n\r\n                &:hover {\r\n                    background: rgba(130, 177, 148, 0.75);\r\n                }\r\n            }\r\n\r\n            @media (max-width: 990px) {\r\n                position: static;\r\n                max-height: none;\r\n                overflow-y: visible;\r\n                padding-right: 0;\r\n                padding-bottom: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    &__main {\r\n        padding-right: 35px;\r\n\r\n        @media (max-width: 990px) {\r\n            padding-right: 0;\r\n        }\r\n    }\r\n\r\n    &__price {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n        margin-top: 12px;\r\n        font-family: inherit;\r\n    }\r\n\r\n    .price-icon {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        width: 32px;\r\n        height: 32px;\r\n        border-radius: 50%;\r\n        background-color: #e8f5e9;\r\n        color: #2e7d32;\r\n    }\r\n\r\n    .price-label {\r\n        font-size: 0.95rem;\r\n        color: #666;\r\n        font-weight: 500;\r\n    }\r\n\r\n    .price-value {\r\n        font-size: 1.1rem;\r\n        font-weight: 700;\r\n        color: #2e7d32;\r\n        letter-spacing: 0.5px;\r\n    }\r\n\r\n\r\n    &__image {\r\n        max-width: 100%;\r\n        width: 100%;\r\n        border-radius: $border-radius;\r\n        overflow: hidden;\r\n    }\r\n\r\n    &__card {\r\n        margin-top: 20px;\r\n        border: 1px solid $color-primary;\r\n        border-radius: $border-radius;\r\n    }\r\n\r\n    &__card-header {\r\n        padding: 20px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n\r\n        @media (max-width: 768px) {\r\n            align-items: flex-start;\r\n        }\r\n    }\r\n\r\n    &__title {\r\n        font-size: 38px;\r\n        color: $color-primary;\r\n        line-height: 1.2;\r\n\r\n        @media (max-width: 768px) {\r\n            font-size: 28px;\r\n        }\r\n    }\r\n\r\n    &__subtitle {\r\n        font-size: 20px;\r\n        color: $color-primary;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    &__card-content {\r\n        padding: 20px;\r\n        border-top: 1px solid $color-primary;\r\n    }\r\n\r\n    &__description {\r\n        font-size: 16px;\r\n        color: $color-primary;\r\n        font-family: $font-main;\r\n        overflow-wrap: anywhere;\r\n        word-break: break-word;\r\n        white-space: pre-wrap;\r\n        max-width: 100%;\r\n    }\r\n\r\n    &__btn {\r\n        font-size: 16px;\r\n        text-decoration: none;\r\n        color: $color-error;\r\n        border: none;\r\n        background: transparent;\r\n    }\r\n\r\n    &__sticky-panel {\r\n        position: sticky;\r\n        top: 23px;\r\n        z-index: 2;\r\n        margin-bottom: 40px;\r\n    }\r\n\r\n    &__calendar {\r\n        text-align: center;\r\n        max-width: 416px;\r\n        width: 100%;\r\n        margin: 0 auto;\r\n        height: 100%;\r\n\r\n        @media (max-width: 768px) {\r\n            max-width: 100%;\r\n        }\r\n\r\n        @media (max-width: 500px) {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    &__calendar-title {\r\n        font-size: 29px;\r\n        color: #445867;\r\n        font-weight: 700;\r\n        margin-bottom: 0;\r\n        text-align: left;\r\n    }\r\n\r\n    &__calendar-legend {\r\n        display: flex;\r\n        justify-content: center;\r\n        gap: 16px;\r\n        margin: 16px 0;\r\n        padding: 10px;\r\n        // background-color: #f8f9fa;\r\n        border-radius: 8px;\r\n        flex-wrap: nowrap;\r\n\r\n        @media (max-width: 500px) {\r\n            gap: 10px;\r\n            padding: 8px;\r\n        }\r\n    }\r\n\r\n    &__legend-item {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n        font-size: 12px;\r\n        color: $color-primary;\r\n        white-space: nowrap;\r\n\r\n        @media (max-width: 768px) {\r\n            font-size: 10px;\r\n        }\r\n    }\r\n\r\n    &__legend-indicator {\r\n        width: 16px;\r\n        height: 16px;\r\n        border-radius: 50%;\r\n\r\n        &--available {\r\n            border: 2px solid #7A9E7E;\r\n            background-color: transparent;\r\n        }\r\n\r\n        &--selected {\r\n            background-color: $color-error;\r\n        }\r\n    }\r\n\r\n    &__calendar-button {\r\n        width: 100%;\r\n        font-family: $font-main;\r\n        border: none;\r\n        border-radius: $border-radius;\r\n        background-color: $color-error;\r\n        padding: 12px;\r\n        color: $color-bg;\r\n        font-size: 21px;\r\n        font-weight: bold;\r\n        margin: 0;\r\n        cursor: pointer;\r\n        transition: transform 0.2s, background-color 0.2s;\r\n\r\n        &:hover {\r\n            background-color: darken($color-error, 5%);\r\n        }\r\n\r\n        &:active {\r\n            transform: scale(0.98);\r\n        }\r\n\r\n        &:disabled {\r\n            background-color: #ccc;\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n\r\n    &__social {\r\n        margin-top: 15px;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 12px;\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    &__social-title {\r\n        font-size: 15px;\r\n        font-weight: bold;\r\n        margin: 0;\r\n        color: #708ca1;\r\n    }\r\n\r\n    &__social-icons {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n    }\r\n\r\n    &__social-wrapper {\r\n        margin-top: 16px;\r\n    }\r\n\r\n    &__back-button-container {\r\n        margin-bottom: 19px;\r\n    }\r\n\r\n    &__back-button {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n        min-height: 42px;\r\n        padding: 0 14px;\r\n        border-radius: 14px;\r\n        border: 1px solid rgba(16, 25, 21, .10);\r\n        background: rgba(248, 244, 240, .92);\r\n        box-shadow: 0 10px 22px rgba(0, 0, 0, .03);\r\n        text-decoration: none;\r\n        color: #13231d;\r\n        font-size: 14px;\r\n        font-weight: 800;\r\n\r\n        &:hover {\r\n            background: #fff;\r\n        }\r\n    }\r\n\r\n\r\n    &__modality-container {\r\n        margin-bottom: 20px;\r\n        // padding: 12px;\r\n        // border-radius: 9px;\r\n        // background-color: #f8fbff;\r\n        // border: 1px solid #e1ecf5;\r\n        font-family: $font-main;\r\n        animation: fadeIn 0.3s ease-in;\r\n    }\r\n\r\n    &__modality-text {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 10px;\r\n        font-size: 14px;\r\n        color: $color-primary;\r\n\r\n        &--presencial {\r\n            svg {\r\n                color: $color-primary;\r\n            }\r\n        }\r\n\r\n        &--virtual {\r\n            svg {\r\n                color: $color-error;\r\n            }\r\n        }\r\n    }\r\n\r\n    &__modality-selection {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 8px;\r\n    }\r\n\r\n    &__modality-header {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 8px;\r\n        font-weight: 600;\r\n        font-size: 14px;\r\n        color: #445867;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    &__radio-group {\r\n        display: flex;\r\n        justify-content: center;\r\n        gap: 15px;\r\n\r\n        &--open {\r\n            background-color: #f8fbff;\r\n            border-radius: 9px;\r\n            border: 1px solid #e1ecf5;\r\n        }\r\n\r\n        @media (max-width: 400px) {\r\n            flex-direction: column;\r\n        }\r\n\r\n        label {\r\n            margin: 0;\r\n            flex: 1;\r\n            border: 1px solid #E0E0E0;\r\n            border-radius: 8px;\r\n            padding: 5px 10px;\r\n            transition: all 0.2s ease;\r\n            background: white;\r\n            display: flow-root;\r\n            justify-content: center;\r\n            align-items: center;\r\n\r\n            &:hover {\r\n                background-color: #f9f9f9;\r\n                border-color: #d0d0d0;\r\n            }\r\n\r\n            &.active-radio {\r\n                border: 2px solid #445867;\r\n                background-color: white;\r\n\r\n                span {\r\n                    font-weight: 700;\r\n                    color: #445867;\r\n                }\r\n            }\r\n\r\n            :global(.MuiTypography-root) {\r\n                font-size: 14px;\r\n                font-weight: 500;\r\n                color: #666;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: space-evenly;\r\n                width: 100%;\r\n\r\n                svg {\r\n                    font-size: 32px;\r\n                }\r\n            }\r\n\r\n            .MuiRadio-root {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    &__consult-value {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        padding: 5px 20px;\r\n        border: 1px solid #E0E0E0;\r\n        border-radius: 10px;\r\n        background-color: #FFFFFF;\r\n        margin-bottom: 25px;\r\n\r\n        &-left {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 10px;\r\n            color: #666;\r\n            font-size: 14px;\r\n            font-weight: 500;\r\n\r\n            span {\r\n                font-size: 16px;\r\n            }\r\n\r\n            svg {\r\n                color: #555;\r\n                font-size: 32px;\r\n            }\r\n        }\r\n\r\n        &-right {\r\n            font-size: 21px;\r\n            font-weight: 800;\r\n            color: #445867;\r\n        }\r\n    }\r\n\r\n\r\n\r\n\r\n    .view-verified-icon {\r\n        color: $color-error;\r\n        font-size: 0.7em !important;\r\n        margin-left: 5px;\r\n    }\r\n\r\n    .view-meta-grid {\r\n        display: grid;\r\n        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n        gap: 15px;\r\n        margin-top: 15px;\r\n        padding: 15px;\r\n        background-color: #fafafa;\r\n        border-radius: 12px;\r\n        border: 1px solid #f0f0f0;\r\n    }\r\n\r\n    .view-meta-item {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 12px;\r\n    }\r\n\r\n    .meta-icon-wrapper {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        width: 40px;\r\n        height: 40px;\r\n        border-radius: 50%;\r\n        background-color: lighten($color-primary, 45%);\r\n        color: $color-primary;\r\n        flex-shrink: 0;\r\n\r\n        &.accent {\r\n            background-color: rgba($color-error, 0.1);\r\n            color: $color-error;\r\n        }\r\n\r\n        &.green {\r\n            background-color: #e8f5e9;\r\n            color: #2e7d32;\r\n        }\r\n    }\r\n\r\n    .meta-content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .meta-label {\r\n        font-size: 0.75rem;\r\n        text-transform: uppercase;\r\n        color: lighten($color-primary, 40%);\r\n        font-weight: 600;\r\n        letter-spacing: 0.5px;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    .meta-value {\r\n        font-size: 0.95rem;\r\n        color: $color-primary;\r\n        font-weight: 600;\r\n        line-height: 1.2;\r\n    }\r\n\r\n    .view-tags-section {\r\n        margin-top: 20px;\r\n\r\n        .tags-header {\r\n            display: flex;\r\n            align-items: center;\r\n            margin-bottom: 8px;\r\n        }\r\n\r\n        .tags-label {\r\n            font-size: 0.9rem;\r\n            color: lighten($color-primary, 20%);\r\n            font-weight: 600;\r\n        }\r\n\r\n        .tags-container {\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            gap: 8px;\r\n        }\r\n\r\n        .tag-badge {\r\n            font-size: 0.75rem;\r\n            padding: 4px 12px;\r\n            background-color: #f0f2f5;\r\n            border-radius: 16px;\r\n            color: #445867;\r\n            border: 1px solid #e0e0e0;\r\n            font-weight: 500;\r\n        }\r\n    }\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-5px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.tabs {\r\n    margin: 0px 0 40px 0;\r\n    border: 1px solid #E1E8ED;\r\n    border-radius: $border-radius;\r\n\r\n    &__content {\r\n        display: flex;\r\n        gap: 20px;\r\n        color: $color-primary;\r\n        padding: 30px 20px;\r\n    }\r\n\r\n    &__title {\r\n        font-size: 24px;\r\n        color: #445867;\r\n        font-weight: 700;\r\n        margin-bottom: 16px;\r\n    }\r\n\r\n    &__image {\r\n        padding-right: 20px;\r\n\r\n        @media (max-width: 768px) {\r\n            padding-right: 0;\r\n            padding-bottom: 20px;\r\n        }\r\n    }\r\n\r\n    &__description {\r\n        font-size: 16px;\r\n        color: $color-primary;\r\n        font-family: $font-main;\r\n        overflow-wrap: anywhere;\r\n        word-break: break-word;\r\n        white-space: pre-wrap;\r\n        max-width: 100%;\r\n        width: 100%;\r\n    }\r\n\r\n    &__empty-state {\r\n        padding: 40px 20px;\r\n        text-align: center;\r\n        color: #8898aa;\r\n        font-size: 15px;\r\n        font-weight: 500;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"professional-detail": `professional-detail_professional-detail__Y-EXR`,
	"professional-detail__content": `professional-detail_professional-detail__content__hrNNX`,
	"professional-detail__content__booking": `professional-detail_professional-detail__content__booking__GDJdB`,
	"professional-detail__main": `professional-detail_professional-detail__main__mvmPb`,
	"professional-detail__price": `professional-detail_professional-detail__price__+IjsU`,
	"price-icon": `professional-detail_price-icon__wCNld`,
	"price-label": `professional-detail_price-label__ANN4S`,
	"price-value": `professional-detail_price-value__nulqi`,
	"professional-detail__image": `professional-detail_professional-detail__image__UKNQb`,
	"professional-detail__card": `professional-detail_professional-detail__card__g-ufe`,
	"professional-detail__card-header": `professional-detail_professional-detail__card-header__XzoXy`,
	"professional-detail__title": `professional-detail_professional-detail__title__Gmnfa`,
	"professional-detail__subtitle": `professional-detail_professional-detail__subtitle__wd4c6`,
	"professional-detail__card-content": `professional-detail_professional-detail__card-content__tUVBj`,
	"professional-detail__description": `professional-detail_professional-detail__description__Tv5bp`,
	"professional-detail__btn": `professional-detail_professional-detail__btn__MKKX4`,
	"professional-detail__sticky-panel": `professional-detail_professional-detail__sticky-panel__sVZjo`,
	"professional-detail__calendar": `professional-detail_professional-detail__calendar__sejOg`,
	"professional-detail__calendar-title": `professional-detail_professional-detail__calendar-title__gKgvr`,
	"professional-detail__calendar-legend": `professional-detail_professional-detail__calendar-legend__eMgdN`,
	"professional-detail__legend-item": `professional-detail_professional-detail__legend-item__X-rx+`,
	"professional-detail__legend-indicator": `professional-detail_professional-detail__legend-indicator__RfdVM`,
	"professional-detail__legend-indicator--available": `professional-detail_professional-detail__legend-indicator--available__V3IDX`,
	"professional-detail__legend-indicator--selected": `professional-detail_professional-detail__legend-indicator--selected__7I0zX`,
	"professional-detail__calendar-button": `professional-detail_professional-detail__calendar-button__KvOxS`,
	"professional-detail__social": `professional-detail_professional-detail__social__gk9Dj`,
	"professional-detail__social-title": `professional-detail_professional-detail__social-title__75dFE`,
	"professional-detail__social-icons": `professional-detail_professional-detail__social-icons__QMahV`,
	"professional-detail__social-wrapper": `professional-detail_professional-detail__social-wrapper__ODtwZ`,
	"professional-detail__back-button-container": `professional-detail_professional-detail__back-button-container__WjAWZ`,
	"professional-detail__back-button": `professional-detail_professional-detail__back-button__oEnZz`,
	"professional-detail__modality-container": `professional-detail_professional-detail__modality-container__e5HVX`,
	"fadeIn": `professional-detail_fadeIn__fWNG7`,
	"professional-detail__modality-text": `professional-detail_professional-detail__modality-text__hF5t0`,
	"professional-detail__modality-text--presencial": `professional-detail_professional-detail__modality-text--presencial__fp8uc`,
	"professional-detail__modality-text--virtual": `professional-detail_professional-detail__modality-text--virtual__papXp`,
	"professional-detail__modality-selection": `professional-detail_professional-detail__modality-selection__+6z38`,
	"professional-detail__modality-header": `professional-detail_professional-detail__modality-header__GRVml`,
	"professional-detail__radio-group": `professional-detail_professional-detail__radio-group__PytGf`,
	"professional-detail__radio-group--open": `professional-detail_professional-detail__radio-group--open__JhoGJ`,
	"active-radio": `professional-detail_active-radio__gbZ0U`,
	"MuiRadio-root": `professional-detail_MuiRadio-root__spAOO`,
	"professional-detail__consult-value": `professional-detail_professional-detail__consult-value__Bw-Le`,
	"professional-detail__consult-value-left": `professional-detail_professional-detail__consult-value-left__vopzl`,
	"professional-detail__consult-value-right": `professional-detail_professional-detail__consult-value-right__Ks2Jz`,
	"view-verified-icon": `professional-detail_view-verified-icon__Wks0S`,
	"view-meta-grid": `professional-detail_view-meta-grid__zdoqw`,
	"view-meta-item": `professional-detail_view-meta-item__LQUoA`,
	"meta-icon-wrapper": `professional-detail_meta-icon-wrapper__+Ww-J`,
	"accent": `professional-detail_accent__v9JkF`,
	"green": `professional-detail_green__wwRa9`,
	"meta-content": `professional-detail_meta-content__u8tVT`,
	"meta-label": `professional-detail_meta-label__9speQ`,
	"meta-value": `professional-detail_meta-value__aGF8C`,
	"view-tags-section": `professional-detail_view-tags-section__zV2f7`,
	"tags-header": `professional-detail_tags-header__SWddH`,
	"tags-label": `professional-detail_tags-label__KRiZ2`,
	"tags-container": `professional-detail_tags-container__EhHQy`,
	"tag-badge": `professional-detail_tag-badge__T3LdL`,
	"tabs": `professional-detail_tabs__+KoDQ`,
	"tabs__content": `professional-detail_tabs__content__WoVRd`,
	"tabs__title": `professional-detail_tabs__title__FZd3M`,
	"tabs__image": `professional-detail_tabs__image__Sgi0Z`,
	"tabs__description": `professional-detail_tabs__description__QAsGY`,
	"tabs__empty-state": `professional-detail_tabs__empty-state__ZvZl+`
};
export default ___CSS_LOADER_EXPORT___;
